var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbonHorizontalBannerDesignSvgrepoCom5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 171,
    viewBox: "0 0 171 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_484_7939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.58 73.6777V97.8408H170.082L164.397 85.0824L170.082 73.6777H156.58Z",
    fill: "#54066F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.795 101.544H153.736V97.8409V73.6779V69.9746H140.795V101.544Z",
    fill: "#54066F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5829 97.8408V73.6777H0.0804749L5.76514 85.4379L0.0804749 97.8408H13.5829Z",
    fill: "#54066F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.423 97.8409V101.544H29.3642V69.9746H16.423V73.6779V97.8409Z",
    fill: "#54066F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2078 67.1326V68.5538V69.975V101.544V102.965V104.387V107.884C32.2078 107.884 64.0471 97.6313 85.0794 97.6313C106.112 97.6313 137.951 107.884 137.951 107.884V104.387V102.965V101.544V69.975V68.5538V67.1326V63.6363C137.951 63.6363 105.939 55.656 85.0436 55.6602C64.1762 55.6643 32.2078 63.6363 32.2078 63.6363V67.1326Z",
    fill: "#54066F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1809 75.0039L58.1311 78.3291L61.9184 79.1435L59.3365 82.0129L59.7268 85.8414L56.1809 84.2897L52.6349 85.8414L53.0252 82.0129L50.4434 79.1435L54.2306 78.3291L56.1809 75.0039Z",
    fill: "#FFFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7277 71.6035L77.678 74.9287L81.4652 75.7431L78.8834 78.6125L79.2737 82.441L75.7277 80.8893L72.1818 82.441L72.5721 78.6125L69.9902 75.7431L73.7775 74.9287L75.7277 71.6035Z",
    fill: "#FFFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5793 71.6035L95.5296 74.9287L99.3168 75.7431L96.7349 78.6125L97.1253 82.441L93.5793 80.8893L90.0333 82.441L90.4237 78.6125L87.8418 75.7431L91.629 74.9287L93.5793 71.6035Z",
    fill: "#FFFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.282 74.1523L114.233 77.4775L118.02 78.2919L115.438 81.1614L115.828 84.9898L112.282 83.4381L108.736 84.9898L109.127 81.1614L106.545 78.2919L110.332 77.4775L112.282 74.1523Z",
    fill: "#FFFBFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_484_7939"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 170,
    fill: "white",
    transform: "translate(0.0820312 0.759766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonHorizontalBannerDesignSvgrepoCom5);
export default __webpack_public_path__ + "static/media/ribbon-horizontal-banner-design-svgrepo-com 5.d7f387a22cf6e51ef7e23a70927f1eeb.svg";
export { ForwardRef as ReactComponent };